import "./lazysizes";
import "./picturefill";
import "./jquery.fitvids";
import "./search";
import "./hamburger";
import "./marketing";
import {withOffsets} from "./lib/utils";
import 'intersection-observer';

jQuery(document).ready(function ($) {
    // Target your .container, .wrapper, .post, etc.
    $(".grid-box-video").fitVids();
    $(".wp-block-embed").fitVids();
    $(".grid-box-wp_html, .grid-box-plaintext").fitVids();

    var listItems = document.querySelectorAll('.teaser-readingtime__info');

    for (var i = 0; i < listItems.length; i++) {
        listItems[i].addEventListener('click', function (event) {
            this.classList.toggle('active');
        });
    }

    if ($('[data-topics="true"]').length > 0) {
        $("body").addClass("has-topics-tab");
    }
    if ($('[data-external="true"]').length > 0) {
        $("body").addClass("has-external-tab");
    }

});

(function ($) {
    $(document).on('facetwp-refresh', function () {
        $('.facetwp-template').addClass("is-refreshing");
        $('.facetwp-template').prepend('<div class="is-loading"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>');
    });
    $(document).on('facetwp-loaded', function () {
        $('.facetwp-template').removeClass("is-refreshing");
        $('.facetwp-template .is-loading').remove();
    });
})(jQuery);

jQuery(document).ready(function ($) {
    $(".grid-container-style__background--blue").each(function () {
        if (!$(this).prev().hasClass("grid-container-style__background--blue")) {
            $(this).addClass("is-first-of-class");
        }
        if (!$(this).next().hasClass("grid-container-style__background--blue")) {
            $(this).addClass("is-last-of-class");
        }
    });
});

jQuery(document).ready(function ($) {
    $(".grid-box-style__toggle").each(function () {
        $(this).append('<button class="grid-box-style__toggle-button">Toggle</button>');
    });

    $("body").on("click", ".grid-box-style__toggle", function () {
        $(this).toggleClass("is-active");
    });
});

window.addEventListener('click', function (e) {
    if (!jQuery(e.target).closest('.entry-aside-card__container.is-active').length) {
        jQuery('.entry-aside-card__container.is-active').removeClass('is-active');
    }
});

jQuery(document).ready(function ($) {
    $("body").on("click", ".entry-summaries-card__toggle", function (e) {
        e.preventDefault();
        $(".entry-summaries__item").removeClass("is-active");
        $("#" + $(this).data("toggle")).toggleClass("is-active");
    });
});

jQuery(document).ready(function ($) {
    $("body").on("click", ".entry-channels-card__toggle", function (e) {
        e.preventDefault();
        $(".entry-channels__item").removeClass("is-active");
        $("#" + $(this).data("toggle")).toggleClass("is-active");
    });

});


jQuery(document).ready(function ($) {
    $("body").on("click", "#toggle-search-filter", function (e) {
        e.preventDefault();
        $("#search-filter").toggleClass("is-active");
        $("body").toggleClass("show-filter-sidebar")
    });

    $("body").on('click', '.entry-aside-card', function () {
        jQuery(".entry-aside-card__container.is-active").removeClass("is-active");
        $(this).parent().addClass('is-active');
    });
});


var timer;

jQuery(window).scroll(function () {
    if (timer) {
        window.clearTimeout(timer);
    }

    timer = window.setTimeout(function () {
        jQuery(".entry-aside-card__container.is-active").removeClass("is-active");
    }, 2);
});

// Lazy Video

(function () {

    var youtube = document.querySelectorAll(".grid-box-video__youtube");

    for (var i = 0; i < youtube.length; i++) {

        var source = "https://img.youtube.com/vi/" + youtube[i].dataset.embed + "/maxresdefault.jpg";

        var image = new Image();
        image.src = source;
        image.addEventListener("load", function () {
            youtube[i].appendChild(image);
        }(i));

        youtube[i].addEventListener("click", function () {

            var iframe = document.createElement("iframe");

            iframe.setAttribute("frameborder", "0");
            iframe.setAttribute("allowfullscreen", "");
            iframe.setAttribute("src", "https://www.youtube.com/embed/" + this.dataset.embed + "?autoplay=1");

            this.innerHTML = "";
            this.appendChild(iframe);
        });
    }
    ;

})();


jQuery(document).ready(function ($) {
    if ($('html[lang="de-DE"]').length === 1) {
        $("<span class='entry-aside-card__headline'><span>Zusammenfassungen auf getAbstract.com</span></span>").insertBefore(".single-post .entry-aside-card__container:first");
    } else {
        $("<span class='entry-aside-card__headline'><span>Related Summaries on getAbstract.com</span></span>").insertBefore(".single-post .entry-aside-card__container:first");

    }
});


const CardIntersectionObserver = (
    stuckClass,
    rootOffset = 100,
    elementsOffset = 25,
) => {

    /**
     *
     * @type {HTMLElement[]}
     */
    const elements = [];
    const pixels = [];

    /**
     *
     * @param {HTMLElement} element
     * @param {Number} depth
     */
    const setDepthClass = (element, depth) => {
        const rmCls = [];
        element.classList.forEach(cls => {
            if (cls.startsWith("depth-")) {
                rmCls.push(cls);
            }
        });
        rmCls.forEach(cls => element.classList.remove(cls));
        element.classList.add(`depth-${depth}`);
    }


    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting && entry.target.getBoundingClientRect().top < 10) {
                    entry.target.parentElement.classList.add(stuckClass);
                } else {
                    entry.target.parentElement.classList.remove(stuckClass);
                }
            });
            const stuckElements = elements.filter(e => e.classList.contains(stuckClass));
            let offsetState = rootOffset;
            let index = 0;
            withOffsets(
                stuckElements,
                (element, offset) => {
                    element.style.top = `${offsetState}px`;
                    offsetState += offset;
                    setDepthClass(element, index++ - stuckElements.length);
                },
                {
                    fullPositionsCount: 3,
                    offset: elementsOffset,
                    minOffset: 2,
                }
            );
        },
        {
            threshold: 1,
        }
    );

    const updateIntersectionPixelOffset = () => {
        const offsets = withOffsets(pixels, undefined, {
            fullPositionsCount: 3,
            offset: elementsOffset,
            minOffset: 1,
        });
        let offsetState = rootOffset;
        offsets.reverse().forEach((offset, index) => {
            const pixel = pixels[index];
            offsetState += offset
            pixel.style.transform = `translateY( -${offsetState}px )`;
        });
    }

    return {
        add: (element) => {

            const intersectionPixel = document.createElement("div");
            intersectionPixel.style.height = "1px";
            intersectionPixel.style.width = "1px";
            intersectionPixel.style.opacity = "0";

            element.prepend(intersectionPixel);
            observer.observe(intersectionPixel);

            elements.push(element);
            pixels.push(intersectionPixel);

            updateIntersectionPixelOffset();
        }
    }
}

const cardIntersectionObserver = CardIntersectionObserver(
    "stuck",
    100,
    27
);

document
    .querySelectorAll('.entry-aside-card__container:not(.is-style-in-context)')
    .forEach((element) => {
        cardIntersectionObserver.add(element);
    });


